import Board from "../../chessBoard/components/Board";
import { ChessSets } from "@chesshotel/constants";
import { useEffect, useRef, useState } from "react";

const settings = { chessSet: ChessSets.CHESSHOTEL_NEW };
const DEFAULT_SIZE = 500;
const MOBILE_BREAKPOINT = 768;

function DisplayBoard({ fen, playingWhite = true }) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [boardSize, setBoardSize] = useState(DEFAULT_SIZE);

  useEffect(() => {
    if (!containerRef.current || typeof window === "undefined") return;

    const updateSize = () => {
      if (!containerRef.current) return;
      if (window.innerWidth < MOBILE_BREAKPOINT) {
        const width = containerRef.current.clientWidth;
        setBoardSize(Math.max(220, Math.min(DEFAULT_SIZE, width)));
      } else {
        setBoardSize(DEFAULT_SIZE);
      }
    };

    updateSize();

    let observer: ResizeObserver | null = null;
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(updateSize);
      observer.observe(containerRef.current);
    }
    window.addEventListener("resize", updateSize);

    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", updateSize);
    };
  }, []);

  return (
    <div ref={containerRef} className="flex justify-start w-full py-8">
      <Board
        settings={settings}
        fen={fen}
        animate={true}
        playingWhite={playingWhite}
        possibleMoves={{}}
        onMoveMade={() => {}}
        size={boardSize}
      />
    </div>
  );
}

export default DisplayBoard as any;
